import { render } from "./SocialMedia.vue?vue&type=template&id=3c98219c&scoped=true&ts=true"
import script from "./SocialMedia.vue?vue&type=script&lang=ts"
export * from "./SocialMedia.vue?vue&type=script&lang=ts"

import "./SocialMedia.vue?vue&type=style&index=0&id=3c98219c&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c98219c"]])

export default __exports__